export const homeStats = [
  { id: "stat-total", label: "收录证据", value: "1,286", unit: "条" },
  { id: "stat-shot", label: "截图材料", value: "642", unit: "组" },
  { id: "stat-audio", label: "录音节选", value: "218", unit: "段" },
  { id: "stat-file", label: "文件材料", value: "426", unit: "份" },
];

export const evidenceEntries = [
  {
    id: "entry-shot",
    icon: "ri-image-2-line",
    name: "截图证据",
    count: 642,
    desc: "按时间戳排序的对话与页面截图，保留原始分辨率",
    accent: "primary",
  },
  {
    id: "entry-audio",
    icon: "ri-mic-line",
    name: "录音文件",
    count: 218,
    desc: "录音节选配文字转写，已标注关键时间点",
    accent: "accent",
  },
  {
    id: "entry-doc",
    icon: "ri-file-text-line",
    name: "文档材料",
    count: 426,
    desc: "PDF、表格与扫描件，附逐页摘要说明",
    accent: "secondary",
  },
  {
    id: "entry-clue",
    icon: "ri-lightbulb-line",
    name: "线索投稿",
    count: 97,
    desc: "读者补充的细节与来源说明，进入人工核验",
    accent: "accent",
  },
  {
    id: "entry-timeline",
    icon: "ri-time-line",
    name: "时间线整理",
    count: 24,
    desc: "按节点梳理前后说法，标注差异位置",
    accent: "secondary",
  },
  {
    id: "entry-compare",
    icon: "ri-scales-3-line",
    name: "对比讨论",
    count: 156,
    desc: "多版本说法并排对照，汇总讨论结论",
    accent: "primary",
  },
];

export const hotTags = [
  { id: "tag-1", name: "海角黑料", count: 320 },
  { id: "tag-2", name: "海角黑料实锤", count: 286 },
  { id: "tag-3", name: "海角黑料证据", count: 264 },
  { id: "tag-4", name: "海角黑料截图", count: 231 },
  { id: "tag-5", name: "海角黑料录音", count: 187 },
  { id: "tag-6", name: "海角黑料文件", count: 165 },
  { id: "tag-7", name: "海角黑料线索", count: 142 },
  { id: "tag-8", name: "时间戳核对", count: 98 },
  { id: "tag-9", name: "说法差异表", count: 76 },
  { id: "tag-10", name: "投稿核验", count: 61 },
  { id: "tag-11", name: "材料索引", count: 54 },
  { id: "tag-12", name: "交叉比对", count: 43 },
];